import useTranslation from 'next-translate/useTranslation';

interface Props {
  className?: string;
}

const StripeDisclaimer = ({ className }: Props): JSX.Element => {
  const { t } = useTranslation();
  return (
    <p className={`stripe-disclaimer ${className ?? ''}`}>
      {t('common:form.payment_secured_with')}
      <a target="_blank" rel="external" href="https://stripe.com/" title="stripe">
        stripe
      </a>
    </p>
  );
};

export default StripeDisclaimer;
